import React from 'react';

const TableHeaderBenefits = ({ classname, tableTitle }) => {
    return (
        <div className={`mt-5 ${classname}`}>
            <h5>
                {tableTitle}
            </h5>
        </div>
    );
};

export default TableHeaderBenefits;